import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetPermissionsQuery,
  GetPermissionsQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { useFetchQuery } from "src/graphql/utils";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getPermissionsQuery = gql(/* GraphQL */ `
  query getPermissions {
    scopesByResource {
      resource
      scopes
    }
  }
`) as TypedDocumentNode<GetPermissionsQuery, GetPermissionsQueryVariables>;

export const useGetPermissionsQuery = () => {
  return useFetchQuery(getPermissionsQuery, {
    toData: (data) => data?.scopesByResource.filter(({ scopes }) => scopes.length > 0) ?? [],
    isEmpty: (data) => isEmpty(data?.scopesByResource.filter(({ scopes }) => scopes.length > 0)),
    uiErrors: { fetchError: "FETCH-PERMISSIONS-ERROR", emptyError: "EMPTY-PERMISSIONS-ERROR" },
  });
};
